import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import strings from "../../../localization/strings"
import { IClientDocument, IJobDocument, IScheduleDocument } from "../../../models"
import ScheduleTimeInfoDetail from "./ScheduleTimeInfoDetail"
import * as api from "../../../api"

interface IProps {
    schedule: IScheduleDocument
    handleSave(schedule: IScheduleDocument)
    handleClose(): void
    job: IJobDocument
    client: IClientDocument
}
interface IState {
    schedule: IScheduleDocument
    selectedClient: IClientDocument
    selectedJob: IJobDocument
}

export default class ScheduleEditDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            schedule: props.schedule,
            selectedClient: null,
            selectedJob: null
        }
        autobind(this)
    }

    componentDidMount() {
        this.props.schedule.ClientId &&
            api.getClient(this.props.schedule.ClientId).then(res =>
                this.setState({
                    selectedClient: res.data
                })
            )
        this.props.schedule.JobId &&
            api.getJob(this.props.schedule.JobId).then(res =>
                this.setState({
                    selectedJob: res.data
                })
            )
    }

    render() {
        return (
            <Dialog
                className="ScheduleEditDialog"
                open
                autoScrollBodyContent
                title={strings.Edit_Schedule}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                contentStyle={{ width: "90%", maxWidth: "none" }}
                actions={[
                    <FlatButton
                        data-intercom-target={"ScheduleEdit-Btn-CloseEditScheduleDialog"}
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"ScheduleEdit-Btn-SaveSchedule"}
                        label={strings.SAVE}
                        primary
                        onClick={() => this.props.handleSave(this.state.schedule)}
                    />
                ]}
            >
                <div style={{ paddingTop: 20 }}>
                    <ScheduleTimeInfoDetail
                        updateScheduleWithoutCheckAssignedEmployeeConstraint
                        schedule={this.state.schedule}
                        handleChange={schedule => this.setState({ schedule })}
                        handleChangeWithoutApiCall={schedule => this.setState({ schedule })}
                        scheduleJob={this.state.selectedJob || this.props.job}
                        scheduleClient={this.state.selectedClient || this.props.client}
                    />
                </div>
            </Dialog>
        )
    }
}